"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sideNav = _interopRequireDefault(require("@/components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("@/components/foot-nav.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _listRow = _interopRequireDefault(require("../../components/cooperationMall/listRow"));
var _noImgListRow = _interopRequireDefault(require("../../components/cooperationMall/noImgListRow"));
var _avatarListRow = _interopRequireDefault(require("../../components/cooperationMall/avatarListRow"));
var _leftImgListRow = _interopRequireDefault(require("../../components/cooperationMall/leftImgListRow"));
var _paging = _interopRequireDefault(require("@/components/paging"));
var _dicDataApi = require("../../api/dicDataApi");
var _util = require("../../assets/static/js/utils/util");
var _api = _interopRequireDefault(require("../../api/api"));
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  components: {
    sideNav: _sideNav.default,
    footNav: _footNav.default,
    paging: _paging.default,
    listRow: _listRow.default,
    noImgListRow: _noImgListRow.default,
    avatarListRow: _avatarListRow.default,
    leftImgListRow: _leftImgListRow.default
  },
  data: function data() {
    return {
      name: '',
      classifyCodeArr: ['ZP', 'QZ', 'MMC', 'MC', 'CF', 'CCF'],
      // MC:卖车,CF:产废
      unSupportCitysArr: ['台湾', '香港特别行政区', '澳门特别行政区', '钓鱼岛'],
      cityData: _appCitysData.default.cityDataWithoutDistrict,
      address: [],
      // 地址
      // tab
      classifyData: [],
      activeClassifyItem: {},
      // 选中的分类对象(分类id,分类code,分类name)
      tabCurrentIndex: 0,
      sortTypeData: [{
        name: '综合排序',
        index: 0
      }, {
        name: '最新发布',
        index: 1
      }],
      queryDayData: [{
        name: '1天内',
        index: 1
      }, {
        name: '7天内',
        index: 7
      }, {
        name: '14天内',
        index: 14
      }, {
        name: '30天内',
        index: 30
      }],
      searchParams: {
        keyword: '',
        // 搜索关键词
        plateId: '',
        // 板块ID
        classifyId: '',
        // 分类ID
        merchantStatus: '',
        // 是否为精选推荐(0:否,1:是)
        sortType: 0,
        // 排序方式(0:综合排序,1:最新发布,2:离我最近(直接查询province、city)。默认的是综合排序来查询)
        queryDay: '',
        // 查询的天数(1:一天内,7:7天内,14:14天内,30:30天内)
        province: '',
        // 省份
        city: '',
        // 城市
        pageSize: 10,
        pageNo: 1
      },
      listData: [],
      dictsData: null,
      listTotalCount: 0,
      showAppDialog: false,
      loaded: false,
      searchDisabled: false
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (window.localStorage.getItem('dics')) {
              _context.next = 8;
              break;
            }
            _context.next = 3;
            return (0, _dicDataApi.getDictsData)();
          case 3:
            this.dictsData = _context.sent;
            _context.next = 6;
            return (0, _dicDataApi.getGoodsTypeData)();
          case 6:
            this.dictsData['GOODS_TYPE'] = _context.sent;
            localStorage.setItem('dics', JSON.stringify(this.dictsData));
          case 8:
            _context.next = 10;
            return this.toGetPlateclassify();
          case 10:
            this.activeClassifyItem = this.classifyData[0];
            this.searchParams.classifyId = this.classifyData[0].classifyId;
            this.getPageMerchantInfoList();
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    // 检查用户登录状态
    checkUserLogin: function checkUserLogin() {
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        this.toLogin();
        return false;
      }
      return true;
    },
    // tab切换
    tabChange: function tabChange(index) {
      // 切换tab后,page要重置
      this.tabCurrentIndex = index;
      this.listData = [];
      this.activeClassifyItem = this.classifyData[index];
      this.$data.searchParams = this.$options.data.call(this).searchParams;
      this.$data.address = this.$options.data.call(this).address;
      this.searchParams.classifyId = this.classifyData[index].classifyId;
      this.getPageMerchantInfoList();
    },
    // 切换
    reset: function reset() {
      this.searchParams.keyword = '';
      this.searchParams.sortType = '';
      this.searchParams.queryDay = '';
      this.searchParams.province = '';
      this.searchParams.city = '';
      this.searchParams.pageNo = '';
      this.$data.address = this.$options.data.call(this).address;
      this.getPageMerchantInfoList();
    },
    // 默认头像随机
    userNormalImg: function userNormalImg() {
      var ico = '';
      if (this.$root.comAvatarArr) {
        ico = this.$root.comAvatarArr[Math.floor(Math.random() * this.$root.comAvatarArr.length)];
      }
      return ico;
    },
    // 排序
    sortTypeChange: function sortTypeChange(val) {
      if (!this.checkUserLogin()) return;
      this.searchParams.sortType = val;
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 地址
    addressChange: function addressChange(value) {
      if (!this.checkUserLogin()) return;
      if (value.length > 0) {
        if (this.unSupportCitysArr.includes(value[0])) {
          this.$message({
            message: '该地区业务还未开展',
            type: 'warning'
          });
          this.address = [];
          this.searchParams.province = '';
          this.searchParams.city = '';
          value = [];
          this.searchParams.pageNo = 1;
          this.getPageMerchantInfoList();
          return;
        } else {
          this.searchParams.province = value[0];
          this.searchParams.city = value[1].indexOf('全省') >= 0 ? '' : value[1];
          this.searchParams.pageNo = 1;
          this.getPageMerchantInfoList();
        }
      } else {
        this.searchParams.province = '';
        this.searchParams.city = '';
        this.searchParams.pageNo = 1;
        this.getPageMerchantInfoList();
      }
    },
    // 发布时间
    queryDayChange: function queryDayChange(val) {
      if (!this.checkUserLogin()) return;
      this.searchParams.queryDay = val;
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 搜索关键词
    toSearch: function toSearch() {
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        this.toLogin();
        return;
      }
      this.searchDisabled = true;
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 未登录弹出登录窗
    toLogin: function toLogin() {
      var that = this;
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        that.$root.dialogFormVisible = true;
      }
    },
    // 分页切换
    pageChange: function pageChange(value) {
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        this.toLogin();
        return;
      }
      this.searchParams.pageNo = value.curPage;
      this.getPageMerchantInfoList();
    },
    // 引导下载弹窗
    toShowPopup: function toShowPopup() {
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        this.toLogin();
        return;
      }
      this.showAppDialog = true;
    },
    // 格式化板块分类数据
    formatClassifyData: function formatClassifyData(data) {
      var _this = this;
      if (data) {
        data.filter(function (item) {
          if (item.plateClassifies && item.plateClassifies.length > 0) {
            item.plateClassifies.filter(function (pcItem) {
              if (pcItem && _this.classifyCodeArr.includes(pcItem.classifyCode)) {
                _this.classifyData.push(pcItem);
              }
            });
          }
        });
      }
    },
    /********************************************** Request **********************************************************/
    // 查询版块分类
    toGetPlateclassify: function () {
      var _toGetPlateclassify = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loadInstance, _yield$Api$apiGetPlat, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.classifyData = [];
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              _context2.next = 4;
              return _api.default.apiGetPlateclassify((0, _util.getParams)('getplateclassify', {}));
            case 4:
              _yield$Api$apiGetPlat = _context2.sent;
              data = _yield$Api$apiGetPlat.data;
              loadInstance.close();
              if (data.proCode == '200') {
                if (data.proData.length > 0) {
                  this.loaded = true;
                  this.formatClassifyData(data.proData);
                }
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function toGetPlateclassify() {
        return _toGetPlateclassify.apply(this, arguments);
      }
      return toGetPlateclassify;
    }(),
    // 列表查询接口
    getPageMerchantInfoList: function () {
      var _getPageMerchantInfoList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var loadInstance, _yield$Api$apiGetPage, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              _context3.next = 3;
              return _api.default.apiGetPageMerchantInfoList((0, _util.getParams)('pageMerchantInfoList', this.searchParams));
            case 3:
              _yield$Api$apiGetPage = _context3.sent;
              data = _yield$Api$apiGetPage.data;
              loadInstance.close();
              this.searchDisabled = false;
              if (!(data.proCode == '200')) {
                _context3.next = 18;
                break;
              }
              this.listTotalCount = data.proData.count;
              if (!(data.proData.dataList.length > 0)) {
                _context3.next = 17;
                break;
              }
              _context3.next = 12;
              return this.formatListItem(data.proData.dataList);
            case 12:
              this.listData = _context3.sent;
              // 在6 和 7 位置插入空对象,放置banner
              this.listData.splice(6, 0, {});
              this.listData.splice(7, 0, {});
              _context3.next = 18;
              break;
            case 17:
              this.listData = [];
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getPageMerchantInfoList() {
        return _getPageMerchantInfoList.apply(this, arguments);
      }
      return getPageMerchantInfoList;
    }(),
    // 将列表字段格式化
    formatListItem: function formatListItem(listData) {
      var _this2 = this;
      var dataArr = listData;
      if (this.activeClassifyItem.classifyCode == 'ZP' || this.activeClassifyItem.classifyCode == 'QZ') {
        dataArr = listData.filter(function (item) {
          // if(!item.ossHeadUrl) item.ossHeadUrl = this.userNormalImg()
          (0, _util.getJobDictItemName)(item);
          return item;
        });
      } else if (this.activeClassifyItem.classifyCode == 'MMC' || this.activeClassifyItem.classifyCode == 'MC') {
        dataArr = listData.filter(function (item) {
          // if(!item.ossHeadUrl) item.ossHeadUrl = this.userNormalImg()
          (0, _util.getCarDictItemName)(item);
          return item;
        });
      } else {
        dataArr = listData.filter(function (item) {
          if (!item.ossHeadUrl) item.ossHeadUrl = _this2.userNormalImg();
          return item;
        });
      }
      return dataArr;
    }
  }
};